import { render, staticRenderFns } from "./HealthGoodHealthQuestion.vue?vue&type=template&id=62100368&scoped=true"
import script from "./HealthGoodHealthQuestion.vue?vue&type=script&lang=js"
export * from "./HealthGoodHealthQuestion.vue?vue&type=script&lang=js"
import style0 from "./HealthGoodHealthQuestion.vue?vue&type=style&index=0&id=62100368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62100368",
  null
  
)

/* custom blocks */
import block0 from "./HealthGoodHealthQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports